import React, { useEffect, useState } from 'react';
import { useExamData } from '../contexts/ExamDataContext';
import Footer from './Footer';

const ExamTypeTest = () => {
  const { getExamTypes } = useExamData();
  const [examTypes, setExamTypes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExamTypes = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getExamTypes();
        setExamTypes(data);
      } catch (err) {
        setError(err?.message || 'Error fetching exam types');
      } finally {
        setLoading(false);
      }
    };
    fetchExamTypes();
  }, [getExamTypes]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{color:'red'}}>Error: {error}</div>;
return (
  <div style={{ paddingLeft: '50px' }}>
    <h1 style={{color:'red',fontWeight:'bold',fontSize:'2em'}}>TEST</h1>
    <h2>Exam Types Test</h2>
    <pre style={{textAlign:'left',background:'#f4f4f4',padding:'1em',borderRadius:'6px'}}>
      {JSON.stringify(examTypes, null, 2)}
    </pre>
    <Footer />
  </div>
);
};
export default ExamTypeTest;
